/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import { MessageBox, Notification } from 'element-ui'
import store from '../store/store';
import router from '../router'
import { loc } from './storage'

// 请求超时时间
axios.defaults.timeout = 120000;
if (process.env.NODE_ENV === 'development') {
  // 开发环境
  axios.defaults.baseURL = process.env.VUE_APP_BASE_API
} else {
  // 生产环境
  axios.defaults.baseURL = window.location.origin
}
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

axios.interceptors.request.use(
  config => {
    if (loc.get('client_token')) {
      config.headers['Authorization'] = 'bearer ' + loc.get('client_token')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    const res = response.data
    if (response.config.headers['xxx-type'] == 'download') {
      return response
    }
    if (res.status !== 1 ) {
      if (res.status == 3 || res.status == 4) {
        return res
      }
      let message = res.msg ? res.msg.split('@@@') : []
      Notification({
        title: message[0] || '操作失败',
        message: message[1],
        type: 'error',
        duration: 5 * 1000,
        offset: 100,
        customClass: 'notifyClass'
      })

      
      // return res;
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error)
    if (error && error.response) {
      // Blob 类型错误
      if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
        const reader = new FileReader()
        reader.readAsText(error.response.data, 'utf-8')
        reader.onload = function (e) {
          const errorMsg = JSON.parse(reader.result).message
          Notification.error({
            title: errorMsg,
            duration: 5000
          })
        }
      }
      // 其他错误
      Notification.error({
        title: error.response.status == 401 ? '登录超时，请重新登录！' : (error.response.data.msg || '接口请求失败'),
        duration: 5000
      })
      switch (error.response.status) {
        case 401:
          store.commit('users/resetToken', null)
          router.replace({name: 'login'})
          break;
        case 403:
          // router.push({ path: '/401' })
          break;
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)


/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/** 
 * 上传图片文件    post方法，对应post请求  
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function upLoad(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/** 
 * 图形验证码   get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function imgCode(url, params = {}) {
  return new Promise((resolve, reject) => {

    axios.get(url, { params, responseType: 'arraybuffer' })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function del(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {params})
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function put(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export default axios


// WEBPACK FOOTER //
// ./src/axios/http.js